module.exports = __webpack_public_path__ + "static/img/quiz-maddie.65eec9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/update/quiz-maddie.png
// module id = zn6k
// module chunks = 1